<template>
  <el-dialog title="管理员操作权限" :visible.sync="centerDialogVisible" width="500px">
    <ul v-for="item in limitContent" :key="item" style="padding:0">
      <li>
        <h4>{{item.name}}</h4>
        <span>{{item.menu}}</span>
      </li>
    </ul>
    <span slot="footer" class="dialog-footer">
      <el-button @click="centerDialogVisible = false">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getLimit } from "../../../api/index";
export default {
  data() {
    return {
      centerDialogVisible: false,
      limitContent: {}
    };
  },
  methods: {
    //查看角色对应权限
    init(id) {
      this.centerDialogVisible = true;
      let data = {
        roleId: id
      };
      getLimit(data)
        .then(res => {
          this.limitContent = res.data;
          console.log(this.limitContent);
        })
        .catch(error => {});
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog {
  .el-dialog__header {
    padding: 18px;
    border-bottom: 1px solid #f4f4f4;
    text-align: left !important;
    .el-dialog__title {
      font-size: 14px;
    }
  }
  .el-dialog__body {
    padding: 40px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
    h4 {
      text-align: center;
      color: #2479ed;
    }
    span {
      color: #323232;
      font-size: 14px;
    }
  }
  .el-dialog__footer {
    text-align: center;
    .dialog-footer {
      width: 80px;
      .el-button--default {
        background-color: #2479ed;
        color: #fff;
        padding:11px 20px;
      }
    }
  }
}
h4,
span {
  margin: 0;
  padding: 0;
}
ul {
  li {
    margin: 20px;
    list-style: none;
    span {
      margin-left: 20px;
    }
  }
}
</style>